import React from "react";
import List from "@material-ui/core/List";
import ListSubheader from "@material-ui/core/ListSubheader";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";
import Chip from "@material-ui/core/Chip";
import Select from "@material-ui/core/Select";
import { Collaborator } from "../../../../../../../../services/collaborator/types/collaborator";
import SimpleArtist from "../../../../../../../../common/types/artist/simple-artist";
import styled from "styled-components";
import { Link } from "react-router-dom";

interface CollaboratorListProps {
  title: string;
  collaborators: Collaborator[];
  artists: SimpleArtist[];
  options?: string[];
  onChange?: (collaborators: Collaborator[]) => void;
}

const StyledLink = styled(Link)`
  color: inherit;
  text-decoration: none;
`;

const inWatchlist = (collaborator: Collaborator, artists: SimpleArtist[]) => {
  return artists.find((a) => a.id === collaborator.collaboratorId)?.inWatchlist;
};

const missingSpotifyId = (
  collaborator: Collaborator,
  artists: SimpleArtist[]
) => {
  return (
    collaborator.type === "COLLABORATOR" &&
    !artists.find((a) => a.id === collaborator.collaboratorId)?.externalIds
      ?.spotify
  );
};

export const CollaboratorList = ({
  title,
  collaborators,
  artists,
  options,
  onChange,
}: CollaboratorListProps) => {
  const handleChange = (collaboratorId: string, role: string) => {
    if (onChange) {
      onChange(
        collaborators.map((oldCollaborator) => ({
          ...oldCollaborator,
          role:
            oldCollaborator.id === collaboratorId ? role : oldCollaborator.role,
        }))
      );
    }
  };

  return (
    <List
      subheader={
        <ListSubheader component="div" id="nested-list-subheader">
          {title}
        </ListSubheader>
      }
    >
      {collaborators.map((collaborator) => (
        <ListItem key={collaborator.id}>
          <ListItemText
            primary={
              options?.length ? (
                <Select
                  value={collaborator.role}
                  onChange={(ev) =>
                    handleChange(collaborator.id, ev.target.value as string)
                  }
                >
                  {options.map((opt, i) => (
                    <MenuItem key={i} value={opt}>
                      <StyledLink
                        to={
                          title === "Collaborators"
                            ? "#"
                            : `/artists/${collaborator.collaboratorId}`
                        }
                      >{`${collaborator.name} (${opt})`}</StyledLink>
                    </MenuItem>
                  ))}
                </Select>
              ) : (
                `${collaborator.name} (${collaborator.role})`
              )
            }
            secondary={
              <div>
                {inWatchlist(collaborator, artists) ? (
                  <Chip size="small" label="WATCHLIST" color="secondary" />
                ) : undefined}
                {missingSpotifyId(collaborator, artists) ? (
                  <Chip
                    size="small"
                    label="MISSING SPOTIFY ID"
                    color="secondary"
                  />
                ) : undefined}
              </div>
            }
          />
        </ListItem>
      ))}
    </List>
  );
};
